<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">The Document</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-one-stonehenge">Chapter One: Stonehenge</a>
<ol class="toc">
<li id="toc-li-5"><a href="#/text/ch004#the-document">The Document</a></li>
</ol>
</li>
<li id="toc-li-6"><a href="#/text/ch005#chapter-two-numbers">Chapter Two: Numbers</a></li>
<li id="toc-li-7"><span href="#/text/ch006#chapter-three-conviction" title="Link target outside of Sample">Chapter Three: Conviction</span></li>
<li id="toc-li-8"><span href="#/text/ch007#chapter-four-status" title="Link target outside of Sample">Chapter Four: Status</span></li>
<li id="toc-li-9"><span href="#/text/ch008#chapter-five-frustration" title="Link target outside of Sample">Chapter Five: Frustration</span></li>
<li id="toc-li-10"><span href="#/text/ch009#chapter-six-breakthrough" title="Link target outside of Sample">Chapter Six: Breakthrough</span></li>
<li id="toc-li-11"><span href="#/text/ch010#chapter-seven-insight" title="Link target outside of Sample">Chapter Seven: Insight</span></li>
<li id="toc-li-12"><span href="#/text/ch011#chapter-eight-the-first-twenty-one-steps-of-time" title="Link target outside of Sample">Chapter Eight: The
          First Twenty-One Steps of Time</span></li>
<li id="toc-li-13"><span href="#/text/ch012#chapter-nine-headway" title="Link target outside of Sample">Chapter Nine: Headway</span></li>
<li id="toc-li-14"><span href="#/text/ch013#chapter-ten-graduate" title="Link target outside of Sample">Chapter Ten: Graduate</span></li>
<li id="toc-li-15"><span href="#/text/ch014#chapter-eleven-thesis" title="Link target outside of Sample">Chapter Eleven: Thesis</span></li>
<li id="toc-li-16"><span href="#/text/ch015#chapter-twelve-marriage" title="Link target outside of Sample">Chapter Twelve: Marriage</span></li>
<li id="toc-li-17"><span href="#/text/ch016#chapter-thirteen" title="Link target outside of Sample">Chapter Thirteen: Legacy</span></li>
<li id="toc-li-19"><span href="#/text/ch018#chapter-fourteen" title="Link target outside of Sample">Chapter Fourteen: Conversation</span></li>
<li id="toc-li-21"><span href="#/text/ch020#chapter-fifteen" title="Link target outside of Sample">Chapter Fifteen: Handover</span></li>
<li id="toc-li-23"><span href="#/text/ch022#epilogue" title="Link target outside of Sample">Epilogue</span></li>
<li id="toc-li-24"><span href="#/text/ch023#chapter-sixteen" title="Link target outside of Sample">Chapter Sixteen: Appendix I</span>
<ol class="toc">
<li id="toc-li-26"><span href="#/text/ch023#the-document-1" title="Link target outside of Sample">The Document</span></li>
</ol>
</li>
<li id="toc-li-27"><span href="#/text/ch025#chapter-seventeen-appendix-ii" title="Link target outside of Sample">Chapter Seventeen: Appendix II</span>
<ol class="toc">
<li id="toc-li-28"><span href="#/text/ch025#the-books-time-reference-table" title="Link target outside of Sample">The Book’s Time Reference
              Table</span></li>
</ol>
</li>
<li id="toc-li-29"><span href="#/text/ch026#chapter-eighteen-appendix-iii" title="Link target outside of Sample">Chapter Eighteen: Appendix III</span>
<ol class="toc">
<li id="toc-li-30"><span href="#/text/ch026#christophers-notes-on-creation" title="Link target outside of Sample">Christopher’s Notes on
              Creation</span></li>
</ol>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?e5a734a8